<!--
@Time : 2020/11/26 1:41 下午
@Author : yekong
@File : paiming.vue
@Software : PhpStorm
-->
<template>
  <div>
    <titles title="纳税次数监控"></titles>
    <div class="paiming2">
      <p class="biaoti">
        本市年度纳税次数为7次,评分得分为80分;较第一名纳税次数多一次;第一名为上海,纳税次数为6次, 其中房产税和土地使用税为联合办理事项
      </p>
      <div class="paimingk">
        <div class="paiming3">
          <div class="head">
            <div class="item1">序号</div>
            <div class="item1">城市</div>
            <div class="item2">次数</div>
            <div class="item3">评价</div>
          </div>
          <div class="body">
            <div class="bodyitem" v-for="(item,index) in list" :key="index">
              <div class="item1">{{ index + 1 }}</div>
              <div class="item2">{{ item.title }}</div>
              <div class="item2">{{ item.day }}次</div>
              <div class="item3">{{ item.fenshu }}分</div>
            </div>
          </div>
        </div>
        <div class="paiming4">
          <hebing></hebing>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titles from "@/components/title";
import hebing from "@/components/nashui/hebing";

export default {
  name: "paiming",
  components: {titles, hebing},
  data: function () {
    return {
      list: [{
        title: '上海',
        day: 6,
        fenshu: 90
      }, {
        title: '大连',
        day: 7,

        fenshu: 80
      }, {
        title: '北京',
        day: 7,

        fenshu: 80
      }, {
        title: '深圳',
        day: 7,
        fenshu: 80
      }]
    }
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  filters: {},
  methods: {
    drawLine() {
      var getsjjg = ['北京', '深圳', '大连', '上海'];
      var getsjjgrs = [35, 30, 22, 12];
      var syjgdata = [];
      for (var i = 0; i < getsjjg.length; i++) {
        syjgdata.push({
          name: getsjjg[i],
          value: getsjjgrs[i]
        })
      }
      var syjgdata2 = [];
      for (var b = 0; b < getsjjg.length; b++) {
        syjgdata2.push({
          name: getsjjg[b],
          value: 100
        })
      }

      var rich = {
        name: {
          color: "rgba(114, 189, 255, 1)",
          fontSize: 30,
          padding: [0, 5],
          fontWeight: '400',
          align: 'right',

        },
        value: {
          color: "rgba(114, 189, 255, 1)",
          fontSize: 30,
          padding: [5, 5],
          fontWeight: '500',
          align: 'right'
        },
        percent: {
          color: "rgba(114, 189, 255, 1)",
          align: 'right',
          fontSize: 30,
          fontWeight: '500',
          padding: [0, 0]
        },
        hr: {
          borderColor: '#DFDFDF',
          width: '100%',
          borderWidth: 0,
          height: 0,
        }
      }
      var colorList = ["#2060db", "#4ca697", "#bcc281", "#0999ee"];

      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart6'))
      // 绘制图表
      myChart.setOption({
        series: [{
          itemStyle: {
            normal: {
              color: function (params) {
                return colorList[params.dataIndex]
              },
              borderColor: '#113872',
              borderWidth: 0,
            }
          },
          type: 'pie',
          radius: ['60%', '80%'],
          center: ["50%", "50%"],
          labelLine: {
            normal: {
              lineStyle: {
                color: 'rgba(114, 189, 255, 1)',
                fontSize: 30
              }
            }
          },
          label: {
            normal: {
              formatter: params => {
                return (
                    '{name|' + params.name + '}'
                );
              },
              rich: rich,
              padding: [0, -1, 0, -1],
              fontSize: 30
            }
          },
          data: syjgdata
        }, {
          itemStyle: {
            normal: {
              color: 'rgba(62,109,255,0.4)',
              fontSize: 30
            }
          },
          type: 'pie',
          hoverAnimation: false,
          radius: ['80%', '90%'],
          center: ["50%", "50%"],
          label: {
            normal: {
              show: false,
              fontSize: 30
            }
          },
          data: [{
            value: 1,
          }],
          z: -1
        }]
      });
    }
  },
  mounted() {
    this.drawLine();

  },
}
</script>

<style lang="scss" scoped>
@import "../../main";

.paiming {
  height: 145px;
  @include flex_start_center();
  font-size: 60px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;

}

.paiming2 {
  width: 1100px;
  height: 560px;

  .head {
    width: 415px;
    height: 55px;
    margin: auto;
    background: rgba(199, 203, 214, 1);
    @include flex_between_center();

    .item1, .item2, .item3 {
      width: 30%;
      @include flex_center_center();
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #0C1638;
    }

    .item3 {
      width: 40%;
    }
  }
}

.body {
  width: 415px;
  margin: auto;
}

.bodyitem {
  height: 92px;
  @include flex_between_center();
  border-bottom: 2px solid rgba(77, 90, 127, 1);
  box-sizing: border-box;

  .item1, .item2, .item3 {
    width: 30%;
    @include flex_center_center();
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ECEFF9;
  }

  .item3 {
    width: 40%;
  }
}

.biaoti {
  height: 57px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ECEFF9;
  line-height: 36px;
  margin-bottom: 30px;
}

.paimingk {
  @include flex_start_start();
  margin-top: 0px;
}

.paiming4 {
  margin-left: 30px;
  height: 494px;
  width: 660px;
}
</style>
